import { axiosInstance } from '.';
import {
    GetKYCDetailsResponseType,
    GetKYCDetailsType,
    RegenerateAccessTokenResponseType,
    RegenerateAccessTokenType,
    RequestKYCResponseType,
    RequestKYCType,
    YpdateAadhaArKYCType,
} from '../../types/digioKYC';

export const digioKYCService = {
    async getKycDetails(params: GetKYCDetailsType) {
        const { data } = await axiosInstance.get('AadhaarKyc/GetKycDetails', {
            params,
        });
        return data as GetKYCDetailsResponseType;
    },

    async requestKyc(param: RequestKYCType) {
        const { data } = await axiosInstance.post(`AadhaarKyc/RequestKyc`, param);
        return data as RequestKYCResponseType;
    },

    async regenerateAccessToken(param: RegenerateAccessTokenType) {
        const { data } = await axiosInstance.post(`AadhaarKyc/RegenerateAccessToken`, param);
        return data as RegenerateAccessTokenResponseType;
    },

    async updateAadharKYC(param: YpdateAadhaArKYCType) {
        await axiosInstance.post(`AadhaarKyc/UpdateAadhaarKyc`, param);
    },
};

export const getKYCRequestIdAndToken = async (
    email: string | null,
    customerName?: string | null,
    candidateId?: string | null,
    referenceId?: string | null
) => {
    const { resultObject } = await digioKYCService.requestKyc({
        customerIdentifier: email || null,
        customerName: null,
        referenceId: null,
        candidateId: candidateId || null,
    });

    return resultObject;
};

export const getKYCDetails = async (requestId: string) => {
    const { resultObject } = await digioKYCService.getKycDetails({ requestId });

    return resultObject;
};

export const regenerateKYCToken = async (requestId: string, identifier: string) => {
    const { resultObject } = await digioKYCService.regenerateAccessToken({ requestId, identifier });

    return resultObject;
};

export const updateAadharKYC = async (requestId: string, candidateId: string) => {
    await digioKYCService.updateAadharKYC({ requestId, candidateId });
};
